import { useState, useEffect, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';

import { useComponentDidMount } from '../../hooks';
import { SelectInput, MultiSelectInput } from '../forms';
import { partnerOfficeActions, PartnerOfficeStore } from '../../../partners/store/offices/partnerOfficeStore';

type ServiceOfficeSelectorProps = Omit<ComponentProps<typeof SelectInput | typeof MultiSelectInput>, 'value' | 'defaultValue'> & {
    partnerOfficeStore?: PartnerOfficeStore,
    officeId: string,
    multiSelect?: boolean,
    excludedValues?: Array<string>,
  };

const ServiceOfficeSelector = (props: ServiceOfficeSelectorProps) => {
  const {
    partnerOfficeStore,
    officeId,
    multiSelect,
    excludedValues,
    name,
    label,
    placeholder,
    disabled,
    ...rest
  } = props;

  const { officeServicesForSelector, officeServicesForSelectorByOfficeId } = partnerOfficeStore;

  const filteredValues = officeServicesForSelector.filter((v) => (!(excludedValues ?? []).includes(v.id)));

  const [loading, setLoading] = useState(false);

  /* const getFilteredData = () => {
    let serviceData = onlyPartnerService ? partnerServices : services;
    if (typeof filter === 'function') {
      serviceData = serviceData.filter(filter);
    }
    if (onlyStationary) { serviceData = serviceData.filter(v => v.stationary); }
    if (onlyNoStationary) { serviceData = serviceData.filter(v => !v.stationary); }
    return serviceData;
  }; */

  const loadData = async () => {
    if (officeId) {
      if ((officeServicesForSelectorByOfficeId !== officeId) && (!loading)) {
        setLoading(true);
        await partnerOfficeActions.getPartnerOfficeServicesForSelector(officeId).finally(() => setLoading(false));
      }
    } else {
      partnerOfficeActions.clearOfficesServicesForSelector();
    }
  };

  useComponentDidMount(() => {
    loadData();
  });

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [officeId]);

  return (
    multiSelect
      ? (
        <MultiSelectInput
          { ...rest }
          isMulti
          noOptionsMessage={ () => { return 'Нет вариантов'; } }
          data={ filteredValues }
          dataTitle='serviceName'
          dataValue='id'
          loading={ loading }
          name={ name }
          label={ label }
          placeholder = { placeholder }          
          disabled= { disabled }
          sort
        />
      )
      : (
        <SelectInput
          { ...rest }
          data={ filteredValues }
          dataTitle='serviceName'
          dataValue='id'
          loading={ loading }
          name={ name }
          label={ label }
          placeholder = { placeholder }          
          disabled = { disabled }
          sort
        />
      )

  );
};

export default inject('partnerOfficeStore')(observer(ServiceOfficeSelector));
